import { HWCLogo } from "./components/HWCLogo.tsx";
import { Outlet } from "@tanstack/react-router";

export function RootLayoutComponent() {
  return (
    <>
      {/* Timber header band — the crest mounted on a dark club wall. */}
      <header className="bg-secondary-900 border-b-2 border-primary-600">
        <div className="container mx-auto flex justify-center px-4 py-6">
          <HWCLogo />
        </div>
      </header>

      <main className="flex-1">
        <div className="container mx-auto px-4 py-10">
          <div className="mx-auto max-w-2xl">
            <div className="text-center">
              <p className="eyebrow">Hobart Workers Club · Est. 1864</p>
              <h1 className="mt-2 text-4xl font-bold tracking-wide text-secondary-800 uppercase sm:text-5xl">
                Membership Application
              </h1>
              <div className="arch-rule mx-auto mt-4 w-40" />
            </div>
            <Outlet />
          </div>
        </div>
      </main>

      {/* Footer — the club's open invitation. */}
      <footer className="bg-secondary-900 text-surface-300">
        <div className="container mx-auto px-4 py-5 text-center">
          <p className="eyebrow text-primary-400">All Welcome</p>
          <p className="mt-1 text-sm text-surface-400">
            Hobart Workers Club — established 1864
          </p>
        </div>
      </footer>
    </>
  );
}
